import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-lg">
                51
              </div>
              <span className="font-heading text-xl font-bold text-background-50">51漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              海量漫画资源免费下载，支持全集离线阅读，手机客户端便捷安装，随时随地畅享漫画阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">
              <a href="/category/rexue" className="hover:text-primary-400 transition-colors">漫画分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/rexue" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">热血漫画</Link></li>
              <li><Link to="/category/lianai" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
              <li><Link to="/category/gaoxiao" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">搞笑漫画</Link></li>
              <li><Link to="/category/maoxian" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">冒险漫画</Link></li>
              <li><Link to="/category/qihuan" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">奇幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">帮助中心</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">版权声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-primary-400" />
                <span>contact@51manhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-primary-400" />
                <span>400-888-0000</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-primary-400" />
                <span>北京市朝阳区漫画大厦</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51漫画 51manhua.com 版权所有 | ICP备2024000000号
          </p>
          <p className="text-xs text-background-500">
            本站所有漫画资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}